import Coupang from "./Coupang";
export { default as CoupangDesciption } from './CoupangDesciption'

export default Coupang;
